import * as React from 'react';
import { useRecordContext } from 'react-admin';

import { makeStyles, Typography } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles((theme) => ({
  text: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '400px',
  },
}));

const resolveNested = (record, source) => {
  if (!record) return undefined;
  if (!source) return undefined;
  const base = record && record.record ? record.record : record;
  if (typeof source !== 'string') return base[source];
  return source.split('.').reduce((acc, key) => {
    if (acc === undefined || acc === null) return undefined;
    return acc[key];
  }, base);
};

function formatadorPadrao(value, record, source) {
  return value;
}

const TextoField = (props) => {
  const classes = useStyles();

  const { source, formatador, textoPadrao } = props;
  const record = useRecordContext(props);
  const textoPadraoLocal = textoPadrao || '-';

  const rawValuePre = resolveNested(record, source);

  const formatadorLocal = formatador || formatadorPadrao;

  const rawValue = formatadorLocal(rawValuePre, record, source);

  const value =
    rawValue === undefined || rawValue === null
      ? textoPadraoLocal
      : typeof rawValue === 'object'
      ? JSON.stringify(rawValue)
      : String(rawValue);

  return (
    <Tooltip title={value} placement="bottom" aria-label="descricao-tooltip">
      <Typography className={classes.text}>{value}</Typography>
    </Tooltip>
  );
};

export default TextoField;
